import React, { useState, useEffect } from "react";
import axios from "axios";
import HeadingCp from "../components/HeadingCp";
import LoadingSpinner from "../components/LoadingSpinner";
import DateFormat from "../components/DateFormat";
import { toast } from "react-toastify";
import Modal from "../components/Modal"; // import the modal!
import ModalWindow from '../components/ModalWindow';
import { Badge } from "react-bootstrap";
import { useNavigate } from 'react-router-dom';
import { PencilSquareIcon, TrashIcon } from '@heroicons/react/24/solid';


const TechTimesheetPayroll = () => {
  const [logs, setLogs] = useState([]);
  const [filteredLogs, setFilteredLogs] = useState([]);
  const [payPeriod, setPayPeriod] = useState("");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // modal edit state
  const [editingRow, setEditingRow] = useState(null);
  const [editData, setEditData] = useState({});
  const [showModal, setShowModal] = useState(false);

  const [techs, setTechs] = useState([]);
  const [selectedTech, setSelectedTech] = useState('');

  const [showCreateModal, setShowCreateModal] = useState(false);
  const [createData, setCreateData] = useState({
    tech_id: '',
    date: '',
    time_type_input: '',
    numberid: '',
    address: '',
    contractor: '',
    job_status: '',
    over_hrs: 0,
    reg_hrs: 0,
    time_in: '',
    time_out: '',
    notes: '',
    pay_period: '',
    billable: '',
    additional_tech: ''
  });

  const apiUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    fetchLogs();
    fetchTechs();
  }, [apiUrl, navigate]);
  
  // const fetchTechs = async () => {
  //   try {
  //     const res = await axios.get(`${apiUrl}/contracts_crud.php?employee_list=true`);
  //     setTechs(Array.isArray(res.data) ? res.data : []);
  //   } catch (error) {
  //     toast.error("Error loading techs");
  //   }
  // };

    const fetchTechs = async () => {
    setLoading(true);
      try {
        const response = await axios.get(`${apiUrl}/service_crud.php?employee_list=true`, {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
        });
        const employees = Array.isArray(response.data) ? response.data : [];
        setTechs(employees);
      } catch (error) {
        if (error.response && error.response.status === 401) {
        navigate('/login');
        } else if (error.response && error.response.status === 403) {
          toast.error("Oops!! you don't have access to this area. Speak to the CFO.", { position: "top-center" });
        }
      } finally {
        setLoading(false);
      }
    };


  const fetchLogs = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${apiUrl}/tech_crud.php`, {
        params: { getListTimesheet: 1 },
      });
      const data = Array.isArray(res.data[0]) ? res.data[0] : [];
      setLogs(data);
      setFilteredLogs(data);
    } catch (error) {
      toast.error("Error fetching payroll data");
    } finally {
      setLoading(false);
    }
  };

  const handlePayPeriodFilter = async () => {
    setLoading(true);
    try {
      const params = { getListTimesheet: 1 };
      if (payPeriod) params.pay_period = payPeriod;
      if (selectedTech) params.tech_id = selectedTech;
  
      const res = await axios.get(`${apiUrl}/tech_crud.php`, { params });
      const data = Array.isArray(res.data[0]) ? res.data[0] : [];
      setFilteredLogs(data);
    } catch (error) {
      toast.error("Filter failed");
    } finally {
      setLoading(false);
    }
  };
  
  const handleCreateChange = e => {
    const { name, value } = e.target;
    setCreateData(prev => ({ ...prev, [name]: value }));
  };

  const handleCreateSubmit = async () => {
    // 1. Validate time_type_input
    if (!createData.time_type_input) {
      toast.error("Time Type is required");
      return;
    }
    // 2. If type is Job, numberid required
    if (createData.time_type_input.toLowerCase() === "job" && !createData.numberid) {
      toast.error("Job Number is required");
      return;
    }
    // 3. Tech required
    if (!createData.tech_id) {
      toast.error("Tech is required");
      return;
    }
    // 4. Validate date
    if (!createData.pay_period) {
      toast.error("pay period is required");
      return;
    }
    setLoading(true);

    try {
     const response = await axios.post(`${apiUrl}/tech_crud.php`, {
        status: "create",
        data: createData,
      });
      if(response.data[0] === 'success'){
        toast.success("Entry created");
      } else {
        toast.error("Failed to create entry: " + response.data[0]);
        setLoading(false);
        return;
      }
      setShowCreateModal(false);
      setCreateData({
        tech_id: '',
        date: '',
        time_type_input: '',
        numberid: '',
        address: '',
        contractor: '',
        job_status: '',
        over_hrs: 0,
        reg_hrs: 0,
        time_in: '',
        time_out: '',
        notes: '',
        pay_period: '',
        billable: '',
        additional_tech: ''
      });
      fetchLogs();
    } catch (error) {
      toast.error("Failed to create entry");
    } finally {
      setLoading(false);
    }
  };

  // open modal
  const handleEdit = (log) => {
    setEditingRow(log.id);
    setEditData({ ...log });
    setShowModal(true);
  };

  // modal form handlers
  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditData((prev) => ({ ...prev, [name]: value }));
  };

  const handleCancelEdit = () => {
    setEditingRow(null);
    setEditData({});
    setShowModal(false);
  };

  const handleSaveEdit = async () => {
    if (!editData.time_type_input) {
      toast.error("Time Type is required");
      return;
    }
    if (editData.time_type_input.toLowerCase() === "job" && !editData.numberid) {
      toast.error("Job Number is required");
      return;
    }
    if(!editData.tech_id) {
      toast.error("Tech is required");
      return;
    }

    setLoading(true);
    try {
     const response =  await axios.post(`${apiUrl}/tech_crud.php`, {
        status: "update",
        data: editData,
      });
      if(response.data[0] === 'success'){
        toast.success("Updated successfully");
        setLoading(false);
      } else {
        toast.error(response.data[1]);
        return;
      }
      setEditingRow(null);
      setEditData({});
      setShowModal(false);
      fetchLogs();
    } catch (error) {
      toast.error("Failed to update");
    } finally {
      setLoading(false);
    }
  };


  const handleDelete = async (logID) => {
    try {
      const response = await axios.post(`${apiUrl}/tech_crud.php`, {
        status: 'deleteLog',
        data: { logID: logID },
        headers: { 'Content-Type': 'application/json' }
      });
      if (response.data.success) {
        toast.success("timesheet logged deleted successfully!", {
          position: "top-center"
        });
         setFilteredLogs(filteredLogs.filter(item => item.id !== logID));
      } else {
        toast.error(response.data.message || "Failed to delete timesheet logged.", {
          position: "top-center"
        });
      }
    } catch (error) {
      toast.error("An error occurred. Please try again.", {
        position: "top-center"
      });
    }
  }  

  return (
    <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 py-8">
      <HeadingCp label="Technician Timesheet Payroll" />

      <div className="flex items-center gap-4 mb-6 bg-gray-100 p-4 rounded-lg">
        <label className="font-medium text-gray-700">
          Pay Period:
          <input
            type="date"
            value={payPeriod}
            onChange={(e) => setPayPeriod(e.target.value)}
            className="ml-2 border rounded px-3 py-1"
          />
        </label>
        <label className="font-medium text-gray-700">
          Tech:
          <select
            value={selectedTech}
            onChange={e => setSelectedTech(e.target.value)}
            className="ml-2 border rounded px-3 py-1"
          >
            <option value="">All</option>
            {techs.map(t => (
              <option key={t.id} value={t.id}>{t.first_name} {t.last_name}</option>
            ))}
          </select>
        </label>
        <button
          className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded text-sm"
          onClick={handlePayPeriodFilter}
        >
          Search
        </button>

        <button
          className="bg-gray-300 hover:bg-gray-400 text-gray-800 px-3 py-2 rounded text-sm"
          onClick={() => {
            setPayPeriod("");
            setSelectedTech("");
            setFilteredLogs(logs);
          }}
        >
          Reset
        </button>
        <button
          className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded text-sm"
          onClick={() => setShowCreateModal(true)}
        >
          + Add Entry
        </button>
      </div>

      {loading ? (
        <LoadingSpinner>Loading...</LoadingSpinner>
      ) : (
        <div className="overflow-auto">
          <table className="min-w-full divide-y divide-gray-300 bg-gray-200 border rounded-lg text-xs sm:text-sm">
            <thead>
              <tr className="divide-x divide-gray-400">
                <th className="py-3.5 px-3 text-left font-semibold text-gray-900">ID</th>
                <th className="py-3.5 px-3 text-left font-semibold text-gray-900">Bill /Tech</th>
                <th className="px-3 py-3.5 text-left font-semibold text-gray-900">Date</th>
                <th className="px-3 py-3.5 text-left font-semibold text-gray-900">Type|#</th>
                <th className="px-3 py-3.5 text-left font-semibold text-gray-900">Site|Contractor</th>
                <th className="px-3 py-3.5 text-left font-semibold text-gray-900">OH</th>
                <th className="px-3 py-3.5 text-left font-semibold text-gray-900">RH</th>
                <th className="px-3 py-3.5 text-left font-semibold text-gray-900">Time In</th>
                <th className="px-3 py-3.5 text-left font-semibold text-gray-900">Time Out</th>
                <th className="px-3 py-3.5 text-left font-semibold text-gray-900">Notes</th>
                <th className="px-3 py-3.5 text-left font-semibold text-gray-900">Pay Period</th>
                <th className="px-3 py-3.5 text-left font-semibold text-gray-900">Additional Tech</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {filteredLogs.map((log, idx) => (
                <tr key={log.id} className={idx % 2 === 0 ? "bg-white" : "bg-gray-100"}>
                  <td className="text-gray-500 px-1 py-2">
                    {log.id}
                  </td>
                  <td className="text-gray-600 px-3 py-2">
                    <span className="mt-0.5 whitespace-nowrap rounded-md px-1.5 py-0.5 text-xs font-medium ring-1 ring-inset">
                     {log.billable === 1 ? "Yes" : "No"}
                    </span><br />
                    {log.employee_name}
                  </td>
                  <td className="text-gray-600 px-3 py-2">
                    <DateFormat date={log.date} />
                  </td>
                  <td className="text-gray-600 px-3 py-2 text-sm">
                    <span className="text-xs text-gray-600 rounded-md px-1.5 py-0.5 ring-1 ring-inset">{log.time_type_input}</span>
                    <p>{log.numberid}</p>
                  </td>
                  <td className={`text-gray-600 log.job_status === completed ? "text-green-600" : "text-red-600"} px-3 py-2 text-sm`}>
                    <p>{log.address}</p>
                    <p className="text-xs text-gray-600">{log.contractor}</p>
                  </td>
                  <td className="text-gray-600 px-3 py-2 text-sm">{log.over_hrs || 0}</td>
                  <td className="text-gray-600 px-3 py-2 text-sm">{log.reg_hrs}</td>
                  <td className="text-gray-600 px-3 py-2 text-sm">{log.time_in}</td>
                  <td className="text-gray-600 px-3 py-2 text-sm">{log.time_out}</td>
                  <td className="text-gray-600 px-3 py-2 text-sm">{log.notes}</td>
                  <td className="text-gray-600 px-3 py-2 text-sm">{log.pay_period}</td>
                  <td className="text-gray-600 px-3 py-2 text-sm">{log.additional_tech}</td>
                  <td className="text-gray-600 px-3 py-2 text-sm">
                    <div className="flex items-center gap-2">
                      <PencilSquareIcon className="h-5 w-5 text-blue-600 cursor-pointer" onClick={() => handleEdit(log)}/>
                      <TrashIcon className="h-5 w-5 text-red-600 cursor-pointer" onClick={() => handleDelete(log.id)}/>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Edit Modal */}
      <Modal isOpen={showModal} onClose={handleCancelEdit}>
        <h2 className="text-lg font-semibold mb-4">Edit Timesheet Entry</h2>

        <div className="grid grid-cols-4 gap-3">
          {/* Date */}
          <label className="col-span-2">
            Date:
            <input
              type="date"
              name="date"
              value={editData.date || ""}
              onChange={handleEditChange}
              className="border rounded px-2 py-2 w-full"
            />
          </label>

          {/* Type */}
          <label className="col-span-2">
            Type:
            <select
              name="time_type_input"
              value={editData.time_type_input || ""}
              onChange={(e) => {
                handleEditChange(e);

                const value = e.target.value;
                if (value === "SC") setEditData((prev) => ({ ...prev, numberid: "School" }));
                else if (value === "SS") setEditData((prev) => ({ ...prev, numberid: "Site-Survey" }));
                else if (value === "sai") setEditData((prev) => ({ ...prev, numberid: "Semi-Annual" }));
                else if (value === "OF") setEditData((prev) => ({ ...prev, numberid: "Office", address: "HQ" }));
                else if (value === "OFF") setEditData((prev) => ({ ...prev, numberid: "OFF", address: "OFF" }));
              }}
              className="border rounded px-2 py-2 w-full"
            >
              <option value="">Select</option>
              <option value="Job">Job #</option>
              <option value="Log">Service#</option>
              <option value="sai">Semi-Annual</option>
              <option value="SS">Site-Survey</option>
              <option value="SC">School</option>
              <option value="OF">Office</option>
              <option value="OFF">OFF</option>
            </select>
          </label>

          {/* Job # */}
          <label className="col-span-2">
            Job #:
            <input
              type="text"
              name="numberid"
              value={editData.numberid || ""}
              onChange={handleEditChange}
              className="border rounded px-2 py-2 w-full"
            />
          </label>

          {/* Address */}
          <label className="col-span-2">
            Address:
            <input
              type="text"
              name="address"
              value={editData.address || ""}
              onChange={handleEditChange}
              className="border rounded px-2 py-2 w-full"
            />
          </label>

          {/* Contractor */}
          <label className="col-span-2">
            Contractor:
            <input
              type="text"
              name="contractor"
              value={editData.contractor || ""}
              onChange={handleEditChange}
              className="border rounded px-2 py-2 w-full"
            />
          </label>

          {/* Pay Period */}
          <label className="col-span-2">
            Pay Period:
            <input
              type="date"
              name="pay_period"
              value={editData.pay_period || ""}
              onChange={handleEditChange}
              className="border rounded px-2 py-2 w-full"
            />
          </label>

          {/* ✅ Status 50% / Over 25% / Reg 25% */}
          <label className="col-span-2">
            Status:
            <input
              type="text"
              name="job_status"
              value={editData.job_status || ""}
              onChange={handleEditChange}
              className="border rounded px-2 py-2 w-full"
            />
          </label>

          <label className="col-span-1">
            Over Hrs:
            <input
              type="number"
              name="over_hrs"
              value={editData.over_hrs || 0}
              onChange={handleEditChange}
              className="border rounded px-2 py-2 w-full"
            />
          </label>

          <label className="col-span-1">
            Reg Hrs:
            <input
              type="number"
              name="reg_hrs"
              value={editData.reg_hrs || 0}
              onChange={handleEditChange}
              className="border rounded px-2 py-2 w-full"
            />
          </label>

          {/* ✅ Time In / Time Out same line */}
          <label className="col-span-2">
            Time In:
            <input
              type="time"
              name="time_in"
              value={editData.time_in || ""}
              onChange={handleEditChange}
              className="border rounded px-2 py-2 w-full"
            />
          </label>

          <label className="col-span-2">
            Time Out:
            <input
              type="time"
              name="time_out"
              value={editData.time_out || ""}
              onChange={handleEditChange}
              className="border rounded px-2 py-2 w-full"
            />
          </label>

          {/* ✅ Notes full width + 2 rows */}
          <label className="col-span-4">
            Notes:
            <textarea
              name="notes"
              value={editData.notes || ""}
              onChange={handleEditChange}
              rows={2}
              className="border rounded px-2 py-2 w-full"
            />
          </label>

          {/* Billable */}
          {/* <label className="col-span-2">
            Billable:
            <select
              name="billable"
              value={editData.billable ?? ""}
              onChange={handleEditChange}
              className="border rounded px-2 py-2 w-full"
            >
              <option value="">Select</option>
              <option value={1}>Yes</option>
              <option value={0}>No</option>
            </select>
          </label> */}

          {/* Additional Tech */}
          <label className="col-span-2">
            Additional Tech:
            <input
              type="text"
              name="additional_tech"
              value={editData.additional_tech || ""}
              onChange={handleEditChange}
              className="border rounded px-2 py-2 w-full"
            />
          </label>
        </div>

        <div className="flex gap-2 mt-6 justify-end">
          <button className="bg-green-600 text-white px-4 py-2 rounded" onClick={handleSaveEdit}>
            Save
          </button>
          <button className="bg-gray-400 text-white px-4 py-2 rounded" onClick={handleCancelEdit}>
            Cancel
          </button>
        </div>
      </Modal>

      <Modal isOpen={showCreateModal} onClose={() => setShowCreateModal(false)}>
        <h2 className="text-lg font-semibold mb-4">Add Timesheet Entry</h2>

        {/* use 4 cols so we can do 50/25/25 cleanly */}
        <div className="grid grid-cols-4 gap-3">
          {/* Tech (half row = 2/4) */}
          <label className="col-span-2">
            Tech:
            <select
              name="tech_id"
              value={createData.tech_id}
              onChange={handleCreateChange}
              className="border rounded px-2 py-2 w-full"
            >
              <option value="">Select</option>
              {techs.map(t => (
                <option key={t.id} value={t.id}>
                  {t.first_name} {t.last_name}
                </option>
              ))}
            </select>
          </label>

          {/* Date (half row = 2/4) */}
          <label className="col-span-2">
            Date:
            <input
              type="date"
              name="date"
              value={createData.date}
              onChange={handleCreateChange}
              className="border rounded px-2 py-2 w-full"
            />
          </label>

          {/* Type (half row = 2/4) */}
          <label className="col-span-2">
            Type:
            <select
              name="time_type_input"
              value={createData.time_type_input || ""}
              onChange={(e) => {
                handleCreateChange(e);

                const value = e.target.value;
                if (value === "SC") setCreateData(prev => ({ ...prev, numberid: "School" }));
                else if (value === "SS") setCreateData(prev => ({ ...prev, numberid: "Site-Survey" }));
                else if (value === "sai") setCreateData(prev => ({ ...prev, numberid: "Semi-Annual" }));
                else if (value === "OF") setCreateData(prev => ({ ...prev, numberid: "Office", address: "HQ" }));
                else if (value === "OFF") setCreateData(prev => ({ ...prev, numberid: "OFF", address: "OFF" }));
              }}
              className="border rounded px-2 py-2 w-full"
            >
              <option value="">Select</option>
              <option value="Job">Job #</option>
              <option value="Log">Service#</option>
              <option value="sai">Semi-Annual</option>
              <option value="SS">Site-Survey</option>
              <option value="SC">School</option>
              <option value="OF">Office</option>
              <option value="OFF">OFF</option>
            </select>
          </label>

          {/* Job # (half row = 2/4) */}
          <label className="col-span-2">
            Job #: | Log #:
            <input
              type="text"
              name="numberid"
              value={createData.numberid}
              onChange={handleCreateChange}
              className="border rounded px-2 py-2 w-full"
            />
          </label>

          {/* Address (half row = 2/4) */}
          <label className="col-span-2">
            Address:
            <input
              type="text"
              name="address"
              value={createData.address}
              onChange={handleCreateChange}
              className="border rounded px-2 py-2 w-full"
            />
          </label>

          {/* Contractor (half row = 2/4) */}
          <label className="col-span-2">
            Contractor:
            <input
              type="text"
              name="contractor"
              value={createData.contractor}
              onChange={handleCreateChange}
              className="border rounded px-2 py-2 w-full"
            />
          </label>

          {/* ✅ Status 50%, Over 25%, Reg 25% */}
          <label className="col-span-2">
            Status:
            <input
              type="text"
              name="job_status"
              value={createData.job_status}
              onChange={handleCreateChange}
              className="border rounded px-2 py-2 w-full"
            />
          </label>

          <label className="col-span-1">
            Over Hrs:
            <input
              type="number"
              name="over_hrs"
              value={createData.over_hrs}
              onChange={handleCreateChange}
              className="border rounded px-2 py-2 w-full"
            />
          </label>

          <label className="col-span-1">
            Reg Hrs:
            <input
              type="number"
              name="reg_hrs"
              value={createData.reg_hrs}
              onChange={handleCreateChange}
              className="border rounded px-2 py-2 w-full"
            />
          </label>

          {/* ✅ Time In / Time Out on same line */}
          <label className="col-span-2">
            Time In:
            <input
              type="time"
              name="time_in"
              value={createData.time_in}
              onChange={handleCreateChange}
              className="border rounded px-2 py-2 w-full"
            />
          </label>

          <label className="col-span-2">
            Time Out:
            <input
              type="time"
              name="time_out"
              value={createData.time_out}
              onChange={handleCreateChange}
              className="border rounded px-2 py-2 w-full"
            />
          </label>

          {/* ✅ Notes spans both columns and 2 rows */}
          <label className="col-span-4">
            Notes:
            <textarea
              name="notes"
              value={createData.notes}
              onChange={handleCreateChange}
              rows={2}
              className="border rounded px-2 py-2 w-full"
            />
          </label>

          {/* Pay Period (half) */}
          <label className="col-span-2">
            Pay Period:
            <input
              type="date"
              name="pay_period"
              value={createData.pay_period}
              onChange={handleCreateChange}
              className="border rounded px-2 py-2 w-full"
            />
          </label>

          {/* Billable (half) */}
          {/* <label className="col-span-2">
            Billable:
            <select
              name="billable"
              value={createData.billable}
              onChange={handleCreateChange}
              className="border rounded px-2 py-2 w-full"
            >
              <option value="">Select</option>
              <option value={1}>Yes</option>
              <option value={0}>No</option>
            </select>
          </label> */}

          {/* Additional Tech full width (optional, keep as half if you want) */}
          <label className="col-span-4">
            Additional Tech:
            <input
              type="text"
              name="additional_tech"
              value={createData.additional_tech}
              onChange={handleCreateChange}
              className="border rounded px-2 py-2 w-full"
            />
          </label>
        </div>

        <div className="flex gap-2 mt-6 justify-end">
          <button
            className="bg-green-600 text-white px-4 py-2 rounded"
            onClick={handleCreateSubmit}
          >
            Create
          </button>
          <button
            className="bg-gray-400 text-white px-4 py-2 rounded"
            onClick={() => setShowCreateModal(false)}
          >
            Cancel
          </button>
        </div>
      </Modal>

    </div>
  );
};

export default TechTimesheetPayroll;
